// extracted by mini-css-extract-plugin
export default {"root":"TitleIssue_root__0g6-b","formContainer":"TitleIssue_formContainer__dIcj5","title":"TitleIssue_title__Jj+UN"};